import(/* webpackMode: "eager", webpackExports: ["default"] */ "/learn-web/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/learn-web/node_modules/next/dist/client/app-dir/link.js");
